export const SponsorList = ({ sponsors }) => {
  return (
    <div className="container flex flex-col mx-auto md:w-9/12 body-font">
      <ul className="grid w-full grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-y-12 md:gap-y-12">
        {sponsors.map((partner, index) => (
          <li key={index} className="flex items-center justify-center">
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={partner.sponsorUrl}
              aria-label={partner.title}
            >
              <img
                src={partner.sponsorLogo[0]?.url}
                referrerPolicy="no-referrer"
                className="w-40"
                alt={partner.sponsorLogo[0]?.altTag || ""}
              />
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}